function readViteEnv(name: string): string | undefined {
  try {
    const env = (import.meta as ImportMeta).env as Record<string, string | undefined> | undefined;
    return env?.[name];
  } catch {
    return undefined;
  }
}

function readNodeEnv(name: string): string | undefined {
  if (typeof process !== 'undefined' && process.env) return process.env[name];
  return undefined;
}

function pickEnv(viteName: string, legacyName: string): string | undefined {
  return (
    readViteEnv(viteName) ??
    readViteEnv(legacyName) ??
    readNodeEnv(viteName) ??
    readNodeEnv(legacyName)
  );
}

export function requireSupabaseEnv() {
  const url = pickEnv('VITE_SUPABASE_URL', 'NEXT_PUBLIC_SUPABASE_URL');
  const anonKey = pickEnv('VITE_SUPABASE_ANON_KEY', 'NEXT_PUBLIC_SUPABASE_ANON_KEY');

  const missing: string[] = [];
  if (!url) missing.push('VITE_SUPABASE_URL (o NEXT_PUBLIC_SUPABASE_URL)');
  if (!anonKey) missing.push('VITE_SUPABASE_ANON_KEY (o NEXT_PUBLIC_SUPABASE_ANON_KEY)');

  if (missing.length > 0) {
    throw new Error(
      `[supabase] Faltan variables de entorno: ${missing.join(', ')}. ` +
        `Defínelas en .env y reinicia "npm run dev"`
    );
  }

  return { url: url!, anonKey: anonKey! };
}

export function readSiteUrl(): string {
  return (
    pickEnv('VITE_SITE_URL', 'NEXT_PUBLIC_SITE_URL') ?? 'https://www.vpslab.com.py'
  );
}
